import { z } from 'zod';

const insightsSubviews = ['findings', 'detail'] as const;
export type InsightsSubview = (typeof insightsSubviews)[number];

/**
 * The whole surface's state lives in the URL, so a link reproduces exactly what someone was looking
 * at — which run, which reading, filtered to which objective, with which finding open.
 *
 * Every field is `.catch(undefined)` rather than plain `.optional()`: these arrive from a
 * hand-editable address bar, and an unrecognised subview should fall back to the default reading
 * rather than throw a route error at someone who mistyped a link.
 */
export const experimentalSearchSchema = z.object({
  runId: z.string().min(1).optional().catch(undefined),
  view: z.enum(insightsSubviews).optional().catch(undefined),
  objective: z.string().min(1).optional().catch(undefined),
  finding: z.string().min(1).optional().catch(undefined),
});

export type ExperimentalSearch = z.infer<typeof experimentalSearchSchema>;
